
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 636 151"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 113.3h78.9v30.2H62v7.6h60v-7.6h-16.9v-30.2H184V0H0v113.3zM7.5 7.6h169v98.1H7.5V7.6zM534.4 16h-82.1c-3.3 0-6 2.7-6 6v123c0 3.3 2.7 6 6 6h82.1c3.3 0 6-2.7 6-6V22c-.1-3.3-2.7-6-6-6zm-.3 128.7h-81.5V22.3h81.5v122.4zM630.6 34h-48.3c-3 0-5.4 2.4-5.4 5.3v106.4c0 2.9 2.4 5.3 5.4 5.3h48.3c3 0 5.4-2.4 5.4-5.3V39.3c0-2.9-2.4-5.3-5.4-5.3zm-24.1 6c.4 0 .8.4.8.8s-.4.8-.8.8-.8-.4-.8-.8.4-.8.8-.8zm26.6 102.4c0 2.1-1.7 3.7-3.8 3.7h-45.8c-2.1 0-3.8-1.7-3.8-3.7V42.7c0-2.1 1.7-3.7 3.8-3.7h15.7c1.7.2 3.3 1.1 3.7 2.3.5 1.3 1.9 2.3 3.5 2.3s3-1 3.5-2.3c.5-1.2 2.1-2.1 3.7-2.3h15.7c2.1 0 3.8 1.7 3.8 3.7v99.7zM214.7 147.3c0 2 1.6 3.7 3.6 3.7H408c2 0 3.6-1.6 3.6-3.7v-3.4h-197v3.4zM386.6 42h-147c-2 0-3.6 1.6-3.6 3.7V140h154.2V45.7c.1-2.1-1.5-3.7-3.6-3.7zm-1.7 90.6H241.5V49.4h143.4v83.2z"}})])
          )
        }
      }
    